var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTranscriptionIcon = function SvgTranscriptionIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10067_1248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07262 15.9582H3.8074V14.552H7.07257V13.1457H3.8074V11.7395H17.3379V0H0.38623V21.8911H7.07257L7.07262 15.9582ZM10.8802 3.30197V4.70822H9.47398V3.30197H10.8802ZM8.04696 3.30197V4.70822H6.64071V3.30197H8.04696ZM5.21365 3.30197V4.70822H3.8074V3.30197H5.21365ZM13.9168 10.3332H3.8074V8.92697H13.9168V10.3332ZM13.9168 7.52072H3.8074V6.11447H13.9168V7.52072Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7236 16.6611H14.6404V18.5555H12.7236V16.6611Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.479 13.1455V23.9998H23.6135V13.1455H8.479ZM11.3174 15.2549H16.0466V21.8904H14.6403V19.9618H12.7236V21.8904H11.3174V15.2549ZM17.4631 20.4842H18.416V16.6611H17.4631V15.2549H20.7751V16.6611H19.8222V20.4842H20.7751V21.8904H17.4631V20.4842Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10067_1248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTranscriptionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transcription-icon.df385902.svg";
export { ForwardRef as ReactComponent };